import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {IRefStatsData, IUserResponseData, IUserUpdateParams, ParamsRefStatsData} from "../models/UserResponse.ts";

export type LoginDataType = {
    contact_telegram_account: string
    referral_code?: string
    timezone?: string
}

export const UserService = {
    fetchUserData(): Promise<AxiosResponse<IUserResponseData>> {
        return $api.get('/user', {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchUserShareData(): Promise<AxiosResponse<string>> {
        return $api.get('/user/share_message', {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchRefStatsData(params: ParamsRefStatsData): Promise<AxiosResponse<IRefStatsData>> {
        return $api.get('/user/ref_stats', {
            params,
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    updateUser(data: IUserUpdateParams): Promise<AxiosResponse<IUserResponseData>> {
        return $api.patch('/user', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    loginUser(data: LoginDataType): Promise<AxiosResponse> {
        return $api.post('/user', data, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
}
